/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pizza
Sushi
Tacos`)
};

const es_dw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pizza
Sushi
Tacos`)
};

const de_dw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pizza
Sushi
Tacos`)
};

const nl_dw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pizza
Sushi
Taco's`)
};

const fr_dw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pizza
Sushi
Tacos`)
};

const it_dw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pizza
Sushi
Tacos`)
};

const pt_br2_dw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pizza
Sushi
Tacos`)
};

const pt_dw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pizza
Sushi
Tacos`)
};

const ja_dw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ピザ
寿司
タコス`)
};

const zh_dw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`披萨
寿司
塔可`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_placeholder", locale)
	if (locale === "en") return en_dw_placeholder(inputs)
	if (locale === "es") return es_dw_placeholder(inputs)
	if (locale === "de") return de_dw_placeholder(inputs)
	if (locale === "nl") return nl_dw_placeholder(inputs)
	if (locale === "fr") return fr_dw_placeholder(inputs)
	if (locale === "it") return it_dw_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_dw_placeholder(inputs)
	if (locale === "pt") return pt_dw_placeholder(inputs)
	if (locale === "ja") return ja_dw_placeholder(inputs)
	return zh_dw_placeholder(inputs)
};